import React from 'react';

export default () => {
  return (
    <footer className="page-footer">
      <div className="footer-copyright">
        <div className="container">
          View Source on&nbsp;
          <a
            href="//github.com/afady/guessing-game"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Footer.js